module.exports = __webpack_public_path__ + "img/boogi.42f99c57.png";